import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type TableIconVariant = 'brand' | 'danger' | 'muted';

const variantClass: Record<TableIconVariant, string> = {
  brand: 'text-brand hover:bg-brand/10',
  danger:
    'text-red-700 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950/40',
  muted: 'text-ink-muted hover:bg-surface-muted',
};

const baseClass =
  'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded transition-colors disabled:pointer-events-none disabled:opacity-50';

type TableIconLinkProps = {
  to: string;
  label: string;
  children: ReactNode;
  variant?: TableIconVariant;
};

export function TableIconLink({
  to,
  label,
  children,
  variant = 'brand',
}: TableIconLinkProps) {
  return (
    <Link
      to={to}
      title={label}
      aria-label={label}
      className={`${baseClass} ${variantClass[variant]}`}
    >
      {children}
    </Link>
  );
}

type TableIconButtonProps = {
  label: string;
  children: ReactNode;
  onClick?: () => void;
  variant?: TableIconVariant;
  disabled?: boolean;
};

export function TableIconButton({
  label,
  children,
  onClick,
  variant = 'brand',
  disabled = false,
}: TableIconButtonProps) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClass} ${variantClass[variant]}`}
    >
      {children}
    </button>
  );
}
